@if (
  {
    sectionsState: sectionsState$ | async,
    listenForMediumScreen: listenForMediumScreen$ | async,
  };
  as comp
) {
  <nav class="wizard-nav" [ngClass]="(locationClasses$ | async) ?? ''">
    @for (section of comp.sectionsState; track section; let i = $index) {
      <button
        class="wizard-nav-btn {{ section?.sectionId }}"
        [ngClass]="{ 'active': section?.active }"
        [routerLink]="[routerLinkBase, section.sectionId, section.routeStart]"
        [disabled]="(!section.completed && !section.active && !section.started && linear) || !comp.listenForMediumScreen">
        <span class="wizard-label">
          {{ section.title }}
        </span>
        <span class="wizard-label-circle"></span>
        @if (!hideMenuCheckMark) {
          <ng-container style="display: flex">
            @if (section?.completed) {
              <fa-icon icon="check" class="green" />
            }
          </ng-container>
        }
      </button>
    }
  </nav>
}
